import styled from 'styled-components';

import { Headline } from '@xing-com/typography';

const TableHeader = styled(Headline)`
  grid-row-start: 1;
`;

export const Styled = {
  TableHeader,
};
